import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import styles from './styles';

class CardDisplay extends React.Component {
    render() {
        const { card, classes } = this.props;

        return (
            <Grid container alignContent="flex-start" className={classes.cardImageRow}>
                <Grid item xs={12} className={classes.cardContainer}>
                    <div
                        className={classes.cardAvatar}
                        style={{
                            background: 'url(data:image/png;base64,' + card.cardRender + ')',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat'
                        }}
                    ></div>
                </Grid>
            </Grid>);
    }
}

CardDisplay.propTypes = {
    card: PropTypes.object.isRequired
};

export default withStyles(styles)(CardDisplay);